package songwritersnotebook.app.utils

class PlaybackState {
    private var currentBeat: Float = 0f

    fun setCurrentBeat(beat: Float) {
        currentBeat = beat
    }

    fun getCurrentBeat(): Float {
        return currentBeat
    }
}
